"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(props) {
  var disabled = props.disabled,
    _props$disabledMessag = props.disabledMessage,
    disabledMessage = _props$disabledMessag === void 0 ? 'You have to save changes first' : _props$disabledMessag,
    children = props.children;
  if (!disabled) {
    return children;
  }
  return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: disabledMessage
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].disabled
  }, children));
};